import React, { useEffect, Suspense, useRef, useState } from 'react';
import { fetchBranchRecruitmentStatus } from './lib/branchrecruitmentstatus';
import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from "react-router-dom"
// import Ceo from './pages/ceo';
// import Complete from './pages/complete';
// import Faq from './pages/faq';
// import MainPage from "./pages/main";
// import Map from './pages/map';
// import Parkgaeul from './pages/parkgaeul';
// import Price from './pages/price';
// import Register from './pages/register';
// import Review from './pages/review';
// import StudySystem from './pages/studysystem';
// import Teachers from './pages/teachers';
import ReactGa from "react-ga4";
import { ReactComponent as Logo } from "./svg/newlogo.svg";
import AttendanceTable from './pages/attendancetable';
import ReportToParent from './pages/reporttoparent';
import NotificationRead from './pages/notificationread';
import NotificationWrite from './pages/notificationwrite';
import NotificationUpdate from './pages/notificationupdate';
import Storys from './pages/storys';
import Storyread from './pages/storyread';
import IntroduceDetail from './pages/introducedetail';
import HeaderTwo from './components/header2';
import Testmap from './pages/testmap';
import WinterSchool from './pages/winterschool';
import RegisterWaiting from './pages/registerwaiting';
import WaitingRegisterFinish from './pages/waitingregisterfinish';
import RegisterWaitingCalendar from './pages/registerwaitingcalendar';
import WaitingRegisterSubmit from './pages/waitingregistersubmit';
import WaitingRegisterInstant from './pages/waitingregisterinstant';
import StudentCard from './studentcardform/studentcard';
import StudentCardFinish from './pages/studentcardfinish';
import Verification from './pages/verification/verification';
import StudentVerification from './pages/verification/studentverification';
import DaechiMap from './pages/daechimap';
import RegisterWinter from './pages/registerwinter';
import WinterComplete from './pages/wintercomplete';
import Parkgaeul2 from './pages/parkgaeul2';
import JustPdfViewer from './pages/justpdfviewer';
import WinterWaitingRegisterFinish from './pages/winterwaitingregisterfinish';
import DailyReport from './pages/dailyreport';
import JustPdfViewer2 from './pages/justpdfviewer2';
import WaitingRegisterInstant2 from './pages/waitingregisterinstant2';
import JustPdfViewer3 from './pages/justpdfviewer3';
import TvShowPage from './pages/tvshowpage';
import TvShowPage2 from './pages/tvshowpage2';
import BundangMap from './pages/bundangmap';
import RegisterWaitingBundang from './pages/registerwaitingbundang';
import LetsCall from './pages/letscall';
import RegisterWaiting2025Winter from './pages/registerwaiting2025winter';
import SongpaMap from './pages/songpamap';
import NewLocation from './pages/newlocation';
import BundangIntroduce from './pages/bundangintroduce';
import SongpaIntroduce from './pages/songpaintroduce';
import JustPdfViewer4 from './pages/justpdfviewer4';
import Teachers2 from './pages/teachers2';
import RegisterWaitingPresentation from './pages/registerwaitingpresentation';
import RegisterPrensentationFinish from './pages/registerpresentationfinish';
import RegisterWaitingPresentationFirstPage from './pages/registerwaitingpresentationfirstpage';
import RegisterWaitingPresentationSms from './pages/registerwaitingpresentationsms';
import InvestMainPage from './pages/invest/main';
import DaeguMap from './pages/daegumap';
import Gangnam2Map from './pages/gangnam2map';
import StudyCafeMainPage from './pages/studycafe/main';
import RegisterFor2026Winter from './pages/registerfor2026winter';
import Complete2 from './pages/complete2';
import RegisterWaiting2025Winter2ForDaegu from './pages/registerwaiting2025winter2fordaegu';
import AttendanceMobileRealForClean from './control/attendancemobilerealforclean';
import GimpoMap from './pages/gimpomap';
// import RegisterWaiting2026 from './pages/registerwaiting2026'; // → /registerWaiting2026는 ConsultApply(새 대기신청 폼)로 교체됨
import RegisterLink from './pages/registerlink';
import WinterPay from './pages/winterpay';
import Complete3 from './pages/complete3';
import SinchonMap from './pages/sinchonmap';
import GangdongMap from './pages/gangdongmap';
import Reviews from './pages/reviews';
import ReviewsRead from './pages/reviewsread';
import MealMenu from './pages/mealmenu';
import HanamMap from './pages/hanammap';
import DongtanMap from './pages/dongtanmap';
import CentumMap from './pages/centummap';
// import MapMain from './pages/mapmain'; // 지점안내 리뉴얼 전환(2026-07)으로 미사용 — 구 페이지 파일은 보존
import SunbaeBriefing from './pages/sunbaebriefing';
import SunbaeBriefingCentum2 from './pages/sunbaebriefing_centum2';
import SunbaeBriefingDongtan from './pages/sunbaebriefing_dongtan';
import SunbaeBriefingGangdong from './pages/sunbaebriefing_gangdong';
import SunbaeBriefingGimpo from './pages/sunbaebriefing_gimpo';
import SunbaeBriefingHanam from './pages/sunbaebriefing_hanam';
import SunbaeBriefingCenter from './pages/sunbaebriefing_center';
import CentumSeatlist from './pages/centum_seatlist';
import CentumNewIntroduce from './pages/centum_newintroduce';
import DongtanNewIntroduce from './pages/dongtan_newintroduce';
import GangdongNewIntroduce from './pages/gangdong_newintroduce';
import GimpoNewIntroduce from './pages/gimpo_newintroduce';
// import KioskMain from './kiosk/kioskmain';
// import Notification from './pages/notification';


const Ceo = React.lazy(() => import("./pages/ceo"));
const Complete = React.lazy(() => import("./pages/complete"));
const Faq = React.lazy(() => import("./pages/faq"));
const MainPage = React.lazy(() => import("./pages/main"));
// 메인 리뉴얼 미리보기 (임시) — 최종 전환 시 "/" 라우트를 이 파일로 교체하고 이 라우트는 제거
const MainV2Preview = React.lazy(() => import("./pages/main copy"));
// 지점안내 리뉴얼 전환 (2026-07) — 구 페이지(pages/mapmain.tsx → daegumap)는 삭제하지 않고 유지
const MapMainV2Preview = React.lazy(() => import("./pages/mapmainv2"));
const Map = React.lazy(() => import("./pages/map"));
const Parkgaeul = React.lazy(() => import("./pages/parkgaeul"));
const Price = React.lazy(() => import("./pages/price"));
// const Register = React.lazy(() => import("./pages/register")); // → /register는 ConsultApply(새 상담신청 폼)로 교체됨
const Review = React.lazy(() => import("./pages/review"));
const StudySystem = React.lazy(() => import("./pages/studysystem"));
const Teachers = React.lazy(() => import("./pages/teachers"));
const Notification = React.lazy(() => import("./pages/notification"));
const KioskMain = React.lazy(() => import("./kiosk/kioskmain"));
const ManagementSystem = React.lazy(() => import("./pages/managementsystem"));
const ConsultApply = React.lazy(() => import("./pages/consultapply"));
// 윈터스쿨 모집 랜딩 (2026-09) — 모바일 디자인 1차, PC 디자인 추가 예정
const Winter = React.lazy(() => import("./pages/winter"));
const WinterPresentation = React.lazy(() => import("./pages/winterpresentation"));
const BriefingTimeSelect = React.lazy(() => import("./pages/briefingtimeselect"));
const DailyReportSample = React.lazy(() => import("./pages/dailyreportsample"));



function App() {

  const ref = useRef<any>(null);
  const [pathName, setPathName] = useState<any>("/");
  const [isFirst, setIsFirst] = useState(true);


  useEffect(() => {
    console.log(window.location.pathname);
    setPathName(window.location.pathname);
  }, [window.location.pathname]);

  // 지점별 모집상태 프리페치 — 상담/대기 팝업 첫 오픈부터 API 값이 바로 보이게 사이트 로드 시점에 받아둔다
  useEffect(() => {
    fetchBranchRecruitmentStatus();
  }, []);

  useEffect(() => {
    console.log(111);
    setTimeout(()=>{
      setIsFirst(false);
    }, 3200);

    ReactGa.initialize([
      {
        trackingId : "G-24CD6Z291K",
        gtagOptions : {sendPageView : false}
      }
    ]);
  }, [])

  return (
    <Router>
      <div id="routing-container">
        <Suspense
          fallback={
            <>
              {
                !isFirst &&
                <HeaderTwo />
              }
              <div ref={ref} className="loadingPageDiv" style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <Logo className="loadingPageLogo" />
                <div>

                </div>
              </div>
            </>
          }
        > 
          <Routes>
            {/* 메인 리뉴얼 v2 전환 (2026-07) — 구 메인(pages/main.tsx)은 삭제하지 않고 유지 */}
            <Route path="/" element={<MainV2Preview />}></Route>
            <Route path="/mainv2preview" element={<MainV2Preview />}></Route>
            <Route path="/ceo" element={<Ceo />}></Route>
            <Route path="/mapmain" element={<MapMainV2Preview />}></Route>
            {/* 인스타 등 지점별 랜딩용 딥링크 — /mapmain/gangnam 등 BranchKey 슬러그 */}
            <Route path="/mapmain/:branch" element={<MapMainV2Preview />}></Route>
            <Route path="/mapmain_test" element={<MapMainV2Preview />}></Route>
            <Route path="/map" element={<Map />}></Route>
            <Route path="/daechimap" element={<DaechiMap />}></Route>
            <Route path="/bundangmap" element={<BundangMap />}></Route>
            <Route path="/songpamap" element={<SongpaMap />}></Route>
            <Route path="/daegumap" element={<DaeguMap />}></Route>
            <Route path="/gangnammap2" element={<Gangnam2Map />}></Route>
            <Route path="/gimpomap" element={<GimpoMap />}></Route>
            <Route path="/sinchonmap" element={<SinchonMap />}></Route>
            <Route path="/gangdongmap" element={<GangdongMap />}></Route>
            <Route path="/hanammap" element={<HanamMap />}></Route>
            <Route path="/dongtanmap" element={<DongtanMap />}></Route>
            <Route path="/centummap" element={<CentumMap />}></Route>
            <Route path="/teachers" element={<Teachers2 />}></Route>
            <Route path="/studysystem" element={<StudySystem />}></Route>
            <Route path="/review" element={<Review />}></Route>
            <Route path="/faq" element={<Faq />}></Route>
            <Route path="/mealmenu" element={<MealMenu />}></Route>
            {/* <Route path="/price" element={<Price />}></Route> */}
            {/* 상담신청 전용 링크 — 기존 문자 발송 URL 유지를 위해 /register가 새 상담신청 폼 */}
            <Route path="/register" element={<ConsultApply intent="consult" />}></Route>
            <Route path="/complete" element={<Complete />}></Route>
            <Route path="/complete2" element={<Complete2 />}></Route>
            <Route path="/complete3" element={<Complete3 />}></Route>
            <Route path="/wintercomplete" element={<WinterComplete />}></Route>
            <Route path="/parkgaeul" element={<Parkgaeul />}></Route>
            <Route path="/parkgaeul2" element={<Parkgaeul2 />}></Route>
            <Route path="/winterschool" element={<WinterSchool />}></Route>
            <Route path="/regular" element={<WinterSchool />}></Route>
            <Route path="/winter" element={<Winter />}></Route>
            <Route path="/2027winterpresentation" element={<WinterPresentation />}></Route>
            <Route path="/winterwaitingregisterfinish" element={<WinterWaitingRegisterFinish />}></Route>
            <Route path="/registerlink" element={<RegisterLink />}></Route>
            <Route path="/winterpay" element={<WinterPay />}></Route>
            
            
            <Route path="/attendancetable" element={<AttendanceTable />}></Route>

            <Route path="/attendancetableforclean" element={<AttendanceMobileRealForClean />}></Route>
            
            <Route path="/consultresult" element={<ReportToParent />}></Route>
            <Route path="/testmap" element={<Testmap />}></Route>
            {/* <Route path="/registerwaiting" element={<RegisterWaiting />}></Route> */}
            <Route path="/registerwaitingbundang" element={<RegisterWaitingBundang />}></Route>
            <Route path="/registerWaiting2025Winter" element={<RegisterWaiting2025Winter />}></Route>
            <Route path="/registerWaiting2025WinterForDaegu" element={<RegisterWaiting2025Winter2ForDaegu />}></Route>

            {/* 대기신청 전용 링크 — 기존 문자 발송 URL 유지를 위해 /registerWaiting2026이 새 대기신청 폼 */}
            <Route path="/registerWaiting2026" element={<ConsultApply intent="waitlist" />}></Route>


            <Route path="/registerFor2026Winter" element={<RegisterFor2026Winter test={true} />}></Route>

            <Route path="/registerFor2026Winter555" element={<RegisterFor2026Winter test={true} />}></Route>

            <Route path="/registerwaiting2025" element={<RegisterWaiting2025Winter />}></Route>
            {/* <Route path="/registerwinter" element={<RegisterWinter />}></Route> */}
            <Route path="/registerwaitingfinish" element={<WaitingRegisterFinish />}></Route>
            <Route path="/registerwaitingcalendar" element={<RegisterWaitingCalendar />}></Route>
            <Route path="/registerwaitingsubmit" element={<WaitingRegisterSubmit />}></Route>
            <Route path="/waitinginstant" element={<WaitingRegisterInstant />}></Route>
            <Route path="/waitingnewinstant" element={<WaitingRegisterInstant2 />}></Route>
            
            <Route path="/notification" element={<Notification />}></Route>
            <Route path="/notificationRead" element={<NotificationRead />}></Route>
            <Route path="/notificationRead7" element={<NotificationUpdate />}></Route>

            <Route path="/reviews" element={<Reviews />}></Route>
            <Route path="/reviewsread" element={<ReviewsRead />}></Route>


            <Route path="/notificationwrite7" element={<NotificationWrite />}></Route>
            <Route path="/storys" element={<Storys />}></Route>
            <Route path="/storyread" element={<Storyread />}></Route>
            <Route path="/introducedetail" element={<IntroduceDetail />}></Route>
            <Route path="/studentcard" element={<StudentCard />}></Route>
            <Route path="/studentcardfinish" element={<StudentCardFinish />}></Route>

            <Route path="/phonenumberverification" element={<Verification />}></Route>

            <Route path="/studentverification" element={<StudentVerification />}></Route>


            <Route path="/kiosk/kioskmain/157292/*" element={<KioskMain />}></Route>

            <Route path="/pdfviewer" element={<JustPdfViewer />}></Route>
            <Route path="/pdfviewer2" element={<JustPdfViewer2 />}></Route>
            <Route path="/pdfviewer3" element={<JustPdfViewer3 />} ></Route>
            <Route path="/pdfviewer4" element={<JustPdfViewer4 />} ></Route>
            <Route path="/dailyreport" element={<DailyReport />}></Route>

            <Route path="/tvshowpage" element={<TvShowPage />}></Route>
            <Route path="/tvshowpage2" element={<TvShowPage2 />}></Route> 

            <Route path="/letscall" element={<LetsCall />}></Route>
            <Route path="/bundangintroduce" element={<BundangIntroduce />}></Route>
            <Route path="/songpaintroduce" element={<SongpaIntroduce />}></Route>

            <Route path="/registerwaitingpresentation" element={<RegisterWaitingPresentationFirstPage />}></Route>
            <Route path="/registerwaitingpresentationsubmit" element={<RegisterWaitingPresentation />}></Route>
            <Route path="/registerwaitingpresentationsms" element={<RegisterWaitingPresentationSms />}></Route>
            <Route path="/registerpresentationfinish" element={<RegisterPrensentationFinish />}></Route>

            <Route path="/investpage" element={<InvestMainPage />}></Route>
            <Route path="/studycafepage" element={<StudyCafeMainPage />}></Route>

            <Route path="/sunbaebriefing" element={<SunbaeBriefing />}></Route>
            <Route path="/sunbaebriefing_centum2" element={<SunbaeBriefingCentum2 />}></Route>
            <Route path="/sunbaebriefing_dongtan" element={<SunbaeBriefingDongtan />}></Route>
            <Route path="/sunbaebriefing_gangdong" element={<SunbaeBriefingGangdong />}></Route>
            <Route path="/sunbaebriefing_gimpo" element={<SunbaeBriefingGimpo />}></Route>
            <Route path="/sunbaebriefing_hanam" element={<SunbaeBriefingHanam />}></Route>
            <Route path="/sunbaebriefing_center" element={<SunbaeBriefingCenter />}></Route>
            <Route path="/centum_seatlist" element={<CentumSeatlist />}></Route>
            <Route path="/centum_newintroduce" element={<CentumNewIntroduce />}></Route>
            <Route path="/dongtan_newintroduce," element={<DongtanNewIntroduce />}></Route>
            <Route path="/gangdong_newintroduce," element={<GangdongNewIntroduce />}></Route>
            <Route path="/gimpo_newintroduce," element={<GimpoNewIntroduce />}></Route>
            <Route path="/briefingtimeselect" element={<BriefingTimeSelect />}></Route>

            <Route path="/operationmanagement" element={<ManagementSystem initialActive="life" />}></Route>
            {/* 관리별 딥링크 — /operationmanagement/life|study|operation|space (mapmain/:branch 패턴) */}
            <Route path="/operationmanagement/:m" element={<ManagementSystem initialActive="life" />}></Route>
            <Route path="/consult" element={<Navigate to="/register" replace />}></Route>
            <Route path="/waiting" element={<Navigate to="/registerwaiting2026" replace />}></Route>
            <Route path="/dailyreportsample" element={<DailyReportSample />}></Route>

          </Routes>
        </Suspense>
      </div>

    </Router>
  );
}

export default App;
